var React = require('react');

function DifficultyLevelUphill (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(-1026.000000, -1307.000000)"},[React.createElement("rect",{"x":"0","y":"0","width":"1440","height":"4389","key":0}),React.createElement("g",{"transform":"translate(111.000000, 1093.000000)","fill":"#854E85","key":1},React.createElement("g",{"transform":"translate(0.000000, 48.000000)"},React.createElement("g",null,React.createElement("g",{"transform":"translate(915.000000, 166.000000)"},React.createElement("polygon",{"points":"20 -4.97379915e-14 40 36.7567568 0 36.7567568"})))))])));
}

DifficultyLevelUphill.defaultProps = {"role":"presentation","viewBox":"0 0 40 37","version":"1.1"};

module.exports = DifficultyLevelUphill;

DifficultyLevelUphill.default = DifficultyLevelUphill;
